module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAARVBMVEX4+v0AAAD4+v34+v3////4+v37/P75+/3////////9/v7////////////////////+/v/////+///+///9/v/8/f7///8T9l+/AAAAFnRSTlMaAA4I7RMkHvrzSue/utmoad+QjFI6o54PlQAAALBJREFUKM+Fk+kSwjAIhFdymKSXJ+//qNbRaZdW6f4L35CFAXBaFCRhVpKwxhYsIMkGB2wUGAt2khUn/FD6Yptr88G+e/8Zc+TS1zotrzcWpjor0vcwyVfVrr9hTQc756olG3eYsqN2tnhQz+1RNbb2pN5B0o8mju3x/Q/uh6JlGJoJeqVZ9xw1ni0UDwuChwNOHrYjyaqFsdiB5jGOjI/XwV8mfxX9RfbP4PiIDk7wBYrUBg5qQmIoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f5.png
// module id = 885
// module chunks = 1